import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/modules/collector_v2/lib/api";

export function useApi(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const fetchData = useCallback(async () => {
    if (!path) {
      setData(null);
      setLoading(false);
      setError("");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(`${API}${path}`);
      setData(response.data);
    } catch (err) {
      setError(err.response?.data?.detail || err.message || "Error consultando API");
    } finally {
      setLoading(false);
    }
  }, [path]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
